import React from 'react';
import ovpFactory from './Ovp/factory';
import Html from './Html';
import Dlc from './Dlc';

export const make = (asset, options) => {
    const type = asset.item_type;

    switch (type.content_type) {
        case 'ovp':
            return ovpFactory(type.host, asset.content, asset, options);
        case 'html':
            return <Html content={asset.content} />;
        case 'dlc':
            return <Dlc asset={asset} />;
    }
};



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/index.js